module.exports = __webpack_public_path__ + "static/media/volunteer.dd48b78a.jpg";